import type { PermissionsHookProps } from '@web-config-app/core';
import { useGetPermissions } from '../use-get-permissions/use-get-permissions';

interface UsePermissionsProps extends PermissionsHookProps {}

/**
 * This hook is used to get the permissions for the current user.
 *
 * @param props.environmentKey - The environment to fetch permissions from
 * @param props.tenantId - The tenant ID for cache isolation
 * @param props.isAuthenticated - Whether the user is authenticated (enables the query when true)
 * @returns {string[]} An array of permissions
 */
export const usePermissions = ({
  environmentKey,
  tenantId,
  isAuthenticated,
}: UsePermissionsProps): string[] => {
  const permissionsQueryResult = useGetPermissions({
    environmentKey,
    tenantId,
    isAuthenticated,
  });

  return permissionsQueryResult.data?.attributes.permissions ?? [];
};
